var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-edit-container",class:_vm.getClass},[_c('NavNewOrder',{attrs:{"on-close-order-edit":_vm.closeOrderEdit}}),_c('MealsMenu'),(_vm.showMealsMenu || (_vm.showOrderForm && _vm.orderOnSite))?_c('OrderPreview'):_vm._e(),(!_vm.orderOnSite && _vm.showOrderForm)?_c('OrderForm'):_vm._e(),_c('order-on-site-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }